import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment-timezone";
import * as yup from "yup";
import Badge from "../components/Badge";

const columnHelper = createColumnHelper();

export const getCraColumns = (onRedraftClick: (event: any, data: any) => void = () => {}, isLoadingImport: boolean = false) => {
  console.log("onRedraftClick", onRedraftClick);
  console.log("isLoadingImport", isLoadingImport);
  //Display Issue
  const truncCell = (value: string | null | undefined, maxWidth: number) => (
    <div className="truncate" title={value || ""} style={{ maxWidth }}>
      {value}
    </div>
  );
  //Display Issue

  const columns = [
    columnHelper.accessor("counterRequestDetail.counter_request_code", {
      header: () => "Request ID",
      enableSorting: true,
    }),
    columnHelper.accessor("created_date", {
      header: () => "Request Date",
      enableSorting: true,
      size: 160,
      cell: (info: any) => {
        const value = moment(info.getValue()).tz("Asia/Kolkata").format("DD MMM YYYY, HH:mm");
        return truncCell(value, 160);
      },
    }),
    columnHelper.accessor("counterRequestDetail.company_division_code.division_name", {
      header: () => "Division",
      enableSorting: true,
      size: 140,
      cell: (info: any) => truncCell(info.getValue(), 140),
    }),
    columnHelper.accessor("counterRequestDetail.drph_lnk_type.dr_ph_lnk_code", {
      header: () => "Counter Type",
      enableSorting: true,
      size: 120,
      cell: (info: any) => truncCell(info.getValue(), 120),
    }),
    columnHelper.accessor("counterRequestDetail.counter_name", {
      header: () => "Doctor Name",
      enableSorting: true,
      size: 160,
      cell: (info: any) => truncCell(info.getValue(), 160),
    }),
    columnHelper.accessor("counterRequestDetail.pharmacy_name", {
      header: () => "Pharmacy Name",
      enableSorting: true,
      size: 160,
      cell: (info: any) => truncCell(info.getValue(), 160),
    }),
    columnHelper.accessor("counterRequestDetail.city_code.city_name", {
      header: () => "City",
      enableSorting: true,
      size: 120,
      cell: (info: any) => {
        const { dr_ph_lnk_code } = info?.row?.original?.counterRequestDetail?.drph_lnk_type || {};
        const isPharmacy = ["INDPH-PH", "INDPH-HS"].includes(dr_ph_lnk_code);
        const value = isPharmacy
          ? info?.row?.original?.counterRequestDetail?.pharmacy_city_code?.city_name
          : info.getValue()?.toString()?.toUpperCase();
        return truncCell(value, 120);
      },
    }),
    columnHelper.accessor("counterRequestDetail.city_code.district_code.state_code.state_name", {
      header: () => "State",
      enableSorting: true,
      size: 120,
      cell: (info: any) => {
        const { dr_ph_lnk_code } = info?.row?.original?.counterRequestDetail?.drph_lnk_type || {};
        const isPharmacy = ["INDPH-PH", "INDPH-HS"].includes(dr_ph_lnk_code);
        const value = isPharmacy
          ? info?.row?.original?.counterRequestDetail?.pharmacy_city_code?.district_code?.state_code?.state_name
          : info.getValue()?.toString()?.toUpperCase();
        return truncCell(value, 120);
      },
    }),
    columnHelper.accessor("counterRequestDetail.hq_name", {
      header: () => "HQ Name",
      enableSorting: true,
      size: 130,
      cell: (info: any) => truncCell(info.getValue(), 130),
    }),
    columnHelper.accessor("counterRequestDetail.current_status", {
      header: () => "Status",
      enableSorting: true,
      size: 110,
      cell: (info: any) => {
        const status = info.getValue();
        let valueToShow = "pending";
        let variant = "default";
        if (status?.toString()?.toLowerCase() === "pending") {
          variant = "warning";
          valueToShow = "Pending";
        } else if (status?.toString()?.toLowerCase() === "rejected") {
          variant = "error";
          valueToShow = "Rejected";
        } else if (status?.toString()?.toLowerCase() === "approval") {
          variant = "success";
          valueToShow = "Approved";
        } else {
          variant = "default";
          valueToShow = status?.toString();
        }

        return (
          <Badge variant={variant} className="capitalize">
            {valueToShow}
          </Badge>
        );
      },
    }),
    columnHelper.accessor("counterRequestDetail.request_type", {
      header: () => "Request Type",
      enableSorting: true,
      size: 120,
      cell: (info: any) => truncCell(info.getValue(), 120),
    }),
  ];

  return columns;
};

export const getProductSchema = (isAllProducts: boolean, dropdownConfiguredPriceId: string[]) => {
  return yup.object().shape({
    // doctor_name: yup.string().required("Doctor Name is required"),
    company_divisioncode: yup.object().required("Division is required"),
    companyProduct: isAllProducts ? yup.object().notRequired().nullable() : yup.object().required("Item selection is required"),
    Period: yup.lazy((value) =>
      typeof value === "object" ? yup.object().required("Period type is required") : yup.string().required("Period type is required")
    ),
    PeriodLimit: yup
      .number()
      .integer()
      .required("Period limit is required")
      .test(
        "period-limit-max-5-digits",
        "Period limit should not exceed 5 digits",
        function (value: any) {
          if (!value) return true;
          return value.toString().length <= 5;
        }
      ),
    Min_Order_Qty: yup.number().integer().required("Minimum Quantity is required").positive("Minimum Quantity must be greater than 0")
      .test(
        "min-qty-max-5-digits",
        "Min Qty should not exceed 5 digits",
        function (value: any) {
          if (!value) return true;
          return value.toString().length <= 5;
        }
      ),
    Max_Order_Qty: yup
      .number()
      .integer()
      .required("Maximum Quantity is required")
      .positive("Maximum Quantity must be greater than zero")
      .moreThan(yup.ref("Min_Order_Qty"), "Maximum Quantity must be greater than Minimum Quantity")
      .lessThan(yup.ref("PeriodLimit"), "Maximum Quantity must be less than Period Limit")
      .test(
        "max-qty-max-5-digits",
        "Max Qty should not exceed 5 digits",
        function (value: any) {
          if (!value) return true;
          return value.toString().length <= 5;
        }
      ),
      FixedPrice: dropdownConfiguredPriceId?.includes("Fixed Price")
        ? yup
          .object()
          .nullable()
          .test("fixed-price", "Fixed Price is required", function (value) {
            const { Priceldentifier_Id } = this.parent;
            if (Priceldentifier_Id?.description?.toString()?.toLowerCase() === "fixed price") {
              return value !== undefined && value !== null;
            }
            return true;
          })
        : yup
          .number()
          .nullable()
          .test("fixed-price", "Fixed Price is required", function (value) {
            const { Priceldentifier_Id } = this.parent;
            if (Priceldentifier_Id?.description?.toString()?.toLowerCase() === "fixed price") {
              if (value === undefined || value === null) {
                return this.createError({ message: "Fixed Price is required" });
              }
              if (Number(value) <= 0) {
                return this.createError({ message: "Fixed Price must be greater than 0" });
              }
            }
            return true;
          }),
    int_qty: isAllProducts
      ? yup.mixed().nullable().notRequired()
      : yup.number().notRequired().lessThan(yup.ref("Min_Order_Qty"), "Int Quantity must be less than Minimum Quantity"),
    reference_number: yup.string().required("Reference Number is required").max(150, "Reference Number must not exceed 150 characters"),
    Priceldentifier_Id: yup.object().required("Discount selection is required"),
    DiscountOnPtr: dropdownConfiguredPriceId?.includes("Discount On PTR")
      ? yup
          .object()
          .nullable()
          .test("discount-on-ptr", "Discount on PTR is required", function (value) {
            const { Priceldentifier_Id } = this.parent;
            if (Priceldentifier_Id?.description?.toString()?.toLowerCase() === "discount on ptr") {
              return value !== undefined && value !== null;
            }
            return true;
          })
      : yup
          .number()
          .nullable()
          .test("discount-on-ptr", "Discount on PTR is required", function (value) {
            const { Priceldentifier_Id } = this.parent;
            if (Priceldentifier_Id?.description?.toString()?.toLowerCase() === "discount on ptr") {
              if (value === undefined || value === null) {
                return this.createError({ message: "Discount on PTR is required" });
              }
              if (value < 0 || value > 100) {
                return this.createError({ message: "Discount on PTR must be between 0 and 100" });
              }
            }
            return true;
          }),
          
    SchemeQty: dropdownConfiguredPriceId?.includes("Scheme")
      ? yup
        .object()
        .nullable()
        .test("scheme", "Scheme is required", function (value) {
          const { Priceldentifier_Id } = this.parent;
          if (Priceldentifier_Id?.description?.toString()?.toLowerCase() === "scheme") {
            return value !== undefined && value !== null;
          }
          return true;
        })
      : yup
        .number()
        .nullable()
        .test("scheme", "Scheme is required", function (value) {
          const { Priceldentifier_Id } = this.parent;
          if (Priceldentifier_Id?.description?.toString()?.toLowerCase() === "scheme") {
            if (value === undefined || value === null) {
              return this.createError({ message: "Scheme is required" });
            }
            if (Number(value) <= 0) {
              return this.createError({ message: "Scheme must be greater than 0" });
            }
          }
          return true;
        }),
        FreeQty: dropdownConfiguredPriceId?.includes("Scheme")
      ? yup
        .object()
        .nullable()
        .test("free-qty", "Free Quantity is required", function (value) {
          //M10-11981
          const { Priceldentifier_Id, SchemeQty } = this.parent;
          if (SchemeQty?.quantity_cp) {
            return true;
          }
          //M10-11981
          if (Priceldentifier_Id?.description?.toString()?.toLowerCase() === "scheme") {
            return value !== undefined && value !== null;
          }
          return true;
        })
      : yup
        .number()
        .nullable()
        .min(0, 'Free Quantity cannot be negative')
        .test("free-qty", "Free Quantity is required", function (value) {
          const { Priceldentifier_Id } = this.parent;
          if (Priceldentifier_Id?.description?.toString()?.toLowerCase() === "scheme") {
             return value !== undefined && value !== null;
          }
          return true;
        }),
  });
};

export const addProductSchema = yup.object().shape({
  // doctor_name: yup.string().required("Doctor Name is required"),
  company_divisioncode: yup.object().required("Division is required"),
  companyProduct: yup.object().required("Item selection is required"),
  Period: yup.lazy((value) =>
    typeof value === "object" ? yup.object().required("Period type is required") : yup.string().required("Period type is required")
  ),
  PeriodLimit: yup
    .number()
    .required("Period limit is required")
    .test(
      "period-limit-max-5-digits",
      "Period limit should not exceed 5 digits",
      function (value: any) {
        if (!value) return true;
        return value.toString().length <= 5;
      }
    ),
  Min_Order_Qty: yup.number().required("Minimum Quantity is required").positive("Minimum Quantity must be greater than 0").test(
    "min-qty-max-5-digits",
    "Min Qty should not exceed 5 digits",
    function (value: any) {
      if (!value) return true;
      return value.toString().length <= 5;
    }
  ),
  Max_Order_Qty: yup
    .number()
    .required("Maximum Quantity is required")
    .positive("Maximum Quantity must be greater than zero")
    .moreThan(yup.ref("Min_Order_Qty"), "Maximum Quantity must be greater than Minimum Quantity")
    .lessThan(yup.ref("PeriodLimit"), "Maximum Quantity must be less than Period Limit").test(
      "max-qty-max-5-digits",
      "Max Qty should not exceed 5 digits",
      function (value: any) {
        if (!value) return true;
        return value.toString().length <= 5;
      }
    ),
  int_qty: yup.number().notRequired().lessThan(yup.ref("Min_Order_Qty"), "Int Quantity must be less than Minimum Quantity"),
  reference_number: yup.string().required("Reference Number is required").max(150, "Reference Number must not exceed 150 characters"),
  Priceldentifier_Id: yup.object().required("Discount selection is required"),
  DiscountOnPtr: yup
    .number()
    .nullable()
    .test("discount-on-ptr", "Discount on PTR is required", function (value) {
      const { Priceldentifier_Id } = this.parent;
      if (Priceldentifier_Id?.toString()?.toLowerCase() === "discount on ptr") {
        return value !== undefined && value !== null;
      }
      return true;
    }),
});
